export function generateLocaledUrl (path: string, to: string) {
    return path === '/' ? `/${to}` : `${path}${path[path.length - 1] === '/' ? '' : '/'}${to}`;
}
